"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isConsentGranted = void 0;
var constants_1 = require("../utils/constants");
function isConsentGranted(settings) {
    var userConsent = settings.userConsent;
    // undefined userConsent is handled as granted (default)
    return !userConsent || userConsent === constants_1.CONSENT_GRANTED;
}
exports.isConsentGranted = isConsentGranted;
